document.addEventListener('DOMContentLoaded', initCartDrawer);

let cartDrawerInit = false;

function initCartDrawer() {
  if (cartDrawerInit) return;
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  cartDrawerInit = true;

  const config = window.CartDrawerConfig || {};
  const overlay = document.querySelector('[data-cart-overlay]');
  const closeBtn = drawer.querySelector('[data-cart-close]');
  const itemsEl = drawer.querySelector('[data-cart-items]');
  const emptyEl = drawer.querySelector('[data-cart-empty]');
  const footerEl = drawer.querySelector('[data-cart-footer]');
  const titleEl = drawer.querySelector('[data-cart-title]');
  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  const checkoutBtn = drawer.querySelector('[data-cart-checkout]');

  let isOpen = false;
  let requestQueue = Promise.resolve();
  let addInFlight = false;

  function enqueue(task) {
    const run = requestQueue.then(task, task);
    requestQueue = run.catch(() => {});
    return run;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, config.moneyFormat);
    }
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function itemTitle(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return `${item.product_title} — ${item.variant_title}`;
    }
    return item.product_title || item.title || '';
  }

  function updateHeaderCount(count) {
    const bubbleBtn = document.getElementById('cart-icon-bubble');
    if (!bubbleBtn) return;

    let bubble = bubbleBtn.querySelector('.site-header__cart-count');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'site-header__cart-count';
        bubbleBtn.appendChild(bubble);
      }
      bubble.textContent = count;
      bubble.hidden = false;
    } else if (bubble) {
      bubble.remove();
    }
  }

  function setVisible(el, visible) {
    if (!el) return;
    el.hidden = !visible;
  }

  function renderCart(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const count = Number(cart?.item_count) || 0;
    const hasItems = count > 0 && items.length > 0;

    if (titleEl) {
      titleEl.textContent = `${config.strings?.title || 'Cart'} (${count})`;
    }
    updateHeaderCount(count);

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart?.total_price || 0);
    if (checkoutBtn) checkoutBtn.href = config.checkoutUrl || '/cart';

    setVisible(emptyEl, !hasItems);
    setVisible(footerEl, hasItems);
    setVisible(itemsEl, hasItems);

    if (!itemsEl) return;

    if (!hasItems) {
      itemsEl.innerHTML = '';
      return;
    }

    itemsEl.innerHTML = items
      .map((item, index) => {
        const line = index + 1;
        const image = item.image
          ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(itemTitle(item))}" class="cart-drawer__item-image" loading="lazy">`
          : '<div class="cart-drawer__item-placeholder" aria-hidden="true"></div>';

        return `
          <article class="cart-drawer__item" data-cart-item data-line="${line}" data-testid="cart-item-${item.variant_id}">
            <div class="cart-drawer__item-media">${image}</div>
            <div class="cart-drawer__item-details">
              <a href="${escapeHtml(item.url)}" class="cart-drawer__item-title" data-testid="link-cart-item-${item.variant_id}">
                ${escapeHtml(itemTitle(item))}
              </a>
              <p class="cart-drawer__item-price">${formatMoney(item.final_price)} ${config.strings?.each || 'each'}</p>
              <div class="cart-drawer__item-actions">
                <button type="button" class="cart-drawer__qty-btn" data-cart-minus data-line="${line}" aria-label="Decrease quantity" data-testid="button-cart-minus-${item.variant_id}">
                  ${minusIcon}
                </button>
                <span class="cart-drawer__qty" data-cart-qty data-testid="text-cart-qty-${item.variant_id}">${item.quantity}</span>
                <button type="button" class="cart-drawer__qty-btn" data-cart-plus data-line="${line}" aria-label="Increase quantity" data-testid="button-cart-plus-${item.variant_id}">
                  ${plusIcon}
                </button>
                <button type="button" class="cart-drawer__remove" data-cart-remove data-line="${line}" aria-label="${escapeHtml(config.strings?.remove || 'Remove')}" data-testid="button-cart-remove-${item.variant_id}">
                  ${trashIcon}
                </button>
              </div>
            </div>
          </article>`;
      })
      .join('');
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!res.ok) throw new Error('Failed to load cart');
    return res.json();
  }

  async function fetchCartWithRetry(retries = 2) {
    let lastError;
    for (let attempt = 0; attempt < retries; attempt += 1) {
      try {
        return await fetchCart();
      } catch (error) {
        lastError = error;
        if (attempt < retries - 1) {
          await new Promise((resolve) => setTimeout(resolve, 150));
        }
      }
    }
    throw lastError;
  }

  async function postCartAdd(body) {
    if (addInFlight) throw new Error('Add already in progress');
    addInFlight = true;

    try {
      const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
      const headers = { Accept: 'application/json' };
      if (!isFormData) headers['Content-Type'] = 'application/json';

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers,
        credentials: 'same-origin',
        body
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.description || data.message || `Add to cart failed (${res.status})`);
      }
      return data;
    } finally {
      addInFlight = false;
    }
  }

  function buildAddBody(variantId, quantity = 1) {
    const id = String(variantId || '').trim();
    const qty = Number(quantity) || 1;
    if (!id) throw new Error('Invalid variant');
    return JSON.stringify({ items: [{ id: Number(id), quantity: qty }] });
  }

  function trackCartAdd(variantId, quantity, cart) {
    if (!window.MetaPixelEvents) return;

    const id = String(variantId || '');
    const item = (cart?.items || []).find((entry) => String(entry.variant_id) === id);

    if (item) {
      window.MetaPixelEvents.trackAddToCart(item);
      return;
    }

    window.MetaPixelEvents.trackAddToCart({
      variant_id: variantId,
      id: variantId,
      quantity: quantity || 1,
      price: 0,
      currency: cart?.currency || 'USD'
    });
  }

  function refresh() {
    return enqueue(async () => {
      const cart = await fetchCartWithRetry();
      renderCart(cart);
      return cart;
    });
  }

  function addItem(variantId, quantity = 1) {
    return enqueue(async () => {
      await postCartAdd(buildAddBody(variantId, quantity));
      const cart = await fetchCartWithRetry();
      renderCart(cart);
      trackCartAdd(variantId, quantity, cart);
      return cart;
    });
  }

  function addFromForm(form) {
    if (!form) return Promise.reject(new Error('Missing form'));
    return enqueue(async () => {
      const formData = new FormData(form);
      if (!formData.get('quantity')) formData.set('quantity', '1');
      const variantId = formData.get('id');
      const quantity = Number(formData.get('quantity')) || 1;
      await postCartAdd(formData);
      const cart = await fetchCartWithRetry();
      renderCart(cart);
      trackCartAdd(variantId, quantity, cart);
      return cart;
    });
  }

  function openDrawerUI() {
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('cart-drawer-open');
  }

  async function open(options = {}) {
    if (!options.skipRefresh) {
      await refresh();
    }
    openDrawerUI();
  }

  async function show() {
    await open({ skipRefresh: false });
  }

  function changeQuantity(line, quantity) {
    return enqueue(async () => {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line, quantity })
      });
      const cart = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(cart.description || cart.message || 'Failed to update cart');
      renderCart(cart);
      if ((cart.item_count || 0) === 0) closeDrawer();
      return cart;
    });
  }

  function clearCart() {
    return enqueue(async () => {
      const res = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('Failed to clear cart');
      const cart = await res.json();
      renderCart(cart);
      closeDrawer();
      return cart;
    });
  }

  document.querySelectorAll('[data-cart-toggle]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      if (isOpen) {
        closeDrawer();
        return;
      }
      open().catch(() => {});
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  const clearBtn = drawer.querySelector('[data-cart-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      clearCart().catch(() => {});
    });
  }

  drawer.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-cart-minus]');
    const plus = event.target.closest('[data-cart-plus]');
    const remove = event.target.closest('[data-cart-remove]');

    if (minus) {
      const line = Number(minus.dataset.line);
      const qtyEl = minus.closest('[data-cart-item]')?.querySelector('[data-cart-qty]');
      const current = Number(qtyEl?.textContent || 1);
      changeQuantity(line, Math.max(0, current - 1)).catch(() => {});
    } else if (plus) {
      const line = Number(plus.dataset.line);
      const qtyEl = plus.closest('[data-cart-item]')?.querySelector('[data-cart-qty]');
      const current = Number(qtyEl?.textContent || 1);
      changeQuantity(line, current + 1).catch(() => {});
    } else if (remove) {
      changeQuantity(Number(remove.dataset.line), 0).catch(() => {});
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen) closeDrawer();
  });

  refresh().catch(() => {});

  window.CartDrawer = {
    open,
    show,
    close: closeDrawer,
    refresh,
    addItem,
    addFromForm,
    updateHeaderCount
  };
}

const minusIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
const plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
const trashIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>';
